// Copied over from
// php-skunkworks/src/WebShop/Domain/Catalog/SearchQueryStringParameters.php
// and adapted to TypeScript
// This should be refactored to use translations but it's tricky because
// the slugs are not the same as either the display names or across languages

import { Language } from '@coolblue-development/constants';

export const SLUGS: {
  [key in 'relevance' | 'bestReviewed' | 'priceLowToHigh' | 'priceHighToLow' | 'mostSold']: {
    [language in Language]: string;
  };
} = {
  relevance: {
    en: 'relevance',
    fr: 'pertinence',
    de: 'relevanz',
    nl: 'relevantie'
  },
  bestReviewed: {
    en: 'highest-rated',
    fr: 'meilleures-notées',
    de: 'am-besten-bewertet',
    nl: 'best-beoordeeld'
  },
  priceLowToHigh: {
    en: 'lowest-price',
    fr: 'prix-les-moins-chers',
    de: 'niedrigster-preis',
    nl: 'laagste-prijs'
  },
  priceHighToLow: {
    en: 'highest-price',
    fr: 'prix-les-plus-chers',
    de: 'hochster-preis',
    nl: 'hoogste-prijs'
  },
  mostSold: {
    en: 'most-sold',
    fr: 'meilleures-ventes',
    de: 'meistverkauftes',
    nl: 'best-verkocht'
  }
};

export type Slug = keyof typeof SLUGS;
